import defaultState from "./state";

const grillaBusquedaPQReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_MODAL_OBSERVACION": {
      return Object.assign({}, state, {
        openModal: action.openModal,
        observacion: action.observacion,
        idPaqueteObservacion: action.idPaquete,
      });
    }

    case "CERRAR_MODAL_OBSERVACION": {
      return Object.assign({}, state, {
        openModal: action.cerrar,
      });
    }

    case "CAMBIAR_OBSERVACION": {
      return Object.assign({}, state, {
        observacion: action.observacion,
      });
    }

    case "ABRIR_MODAL_CARACTERISTICAS": {
      return Object.assign({}, state, {
        openModalCaracteristicas: action.openModal,
        caracteristicasPaquete: action.caracteristicas,
      });
    }

    case "CARGAR_CARACTERISTICAS_MOD": {
      return Object.assign({}, state, {
        caracteristicasPaqueteMod: action.caracteristicas,
      });
    }

    case "CARGAR_DETALLE_MOD": {
      return Object.assign({}, state, {
        detallePaqueteMod: action.detalle,
      });
    }

    case "EDIT_PAQUETE/CAMBIAR_CARACTERISTICA": {
      var newArray = [];
      var newArray2 = [];
      const caracteristicasAct = [...state.caracteristicasPaqueteMod];
      const caracteristicasEdit = [...state.caracteristicasPaqueteEditar];
      newArray = caracteristicasAct;
      newArray2 = caracteristicasEdit;

      const index = newArray.findIndex(o => o.Tipo === action.tipo);
      const index2 = newArray2.findIndex(o => o.Tipo === action.tipo);


      if (index > -1) {
        newArray[index] = { Tipo: action.tipo, Descripcion: action.descripcion };
      }

      if (index2 > -1) {
        newArray2[index2] = { Tipo: action.tipo, Descripcion: action.descripcion };
      } else {
        newArray2.push({ Tipo: action.tipo, Descripcion: action.descripcion });
      }

      return Object.assign({}, state, {
        caracteristicasPaqueteMod: newArray,
        caracteristicasPaqueteEditar: newArray2,
      })
    }

    case "EDIT_PAQUETE/NUEVA_CARACTERISTICA": {
      var newArray = [];
      var newArray2 = [];

      const caracteristicasAct = [...state.caracteristicasPaqueteMod];
      const caracteristicasAdd = [...state.caracteristicasPaqueteAdd];

      newArray = caracteristicasAct;
      newArray2 = caracteristicasAdd;

      const index2 = newArray2.findIndex(o => o.Tipo === action.tipo);
      if (index2 > -1) {
        newArray2[index2] = { Tipo: action.tipo, Descripcion: action.descripcion };
      } else {
        newArray2.push({ Tipo: action.tipo, Descripcion: action.descripcion });
      }

      newArray.push({ Tipo: action.tipo, Descripcion: action.descripcion });

      return Object.assign({}, state, {
        caracteristicasPaqueteMod: newArray,
        caracteristicasPaqueteAdd: newArray2,
      })
    }

    case "EDIT_PAQUETE/BORRAR_CARACTERISTICA": {
      //var newArray2 = [];
      var newArray = [];

      var caracteristicasActMod = [...state.caracteristicasPaqueteMod];
      /*const caracteristicasEli = state.caracteristicasPaqueteEliminar;
      if (caracteristicasEli.length > 0) {
        newArray2 = caracteristicasEli;
        const index2 = newArray2.findIndex(o => o.Tipo === caracteristicasAct[action.index].Tipo);
        if (index2 > -1) {
          newArray2[index2] = caracteristicasAct[action.index];
        } else {
          newArray2.push(caracteristicasAct[action.index]);
        }
      } else {
        newArray2.push(caracteristicasAct[action.index]);
      }*/
      newArray = caracteristicasActMod;
      newArray.splice(action.index, 1);

      return Object.assign({}, state, {
        caracteristicasPaqueteMod: newArray,
        //caracteristicasPaqueteEliminar: newArray2,
      })
    }

    case "EDIT_PAQUETE/BORRAR_PRESTACIONES": {
      var newArray = [];
      var newArray2 = [];
      var aEliminar = action.prestaciones;
      var detalleActual = [...state.detallePaqueteMod];
      newArray = detalleActual;

      for (let i = 0; i < aEliminar.length; i++) {
        newArray[aEliminar[i]] = null;
      }
      for (let i = 0; i < newArray.length; i++) {
        if (newArray[i] != null) {
          newArray2.push(newArray[i]);
        }
      }
      return Object.assign({}, state, {
        detallePaqueteMod: newArray2,
      })
    }

    case "CAMBIAR_PRES_SELECCIONADAS": {
      return Object.assign({}, state, {
        prestacionesSeleccionadasPQ: action.prestacionesSeleccionadasPQ,
      });
    }

    case "CERRAR_MODAL_CARACTERISTICAS": {
      return Object.assign({}, state, {
        openModalCaracteristicas: action.cerrar,
      });
    }

    case "ABRIR_MODAL_DETALLE": {
      return Object.assign({}, state, {
        openModalDetalle: action.openModal,
        detallePaquete: action.detalles,
        totalClinica: action.totalClinica,
        totalHMQ: action.totalHMQ,
        totalMonto: action.totalMonto,
      });
    }

    case "CERRAR_MODAL_DETALLE": {
      return Object.assign({}, state, {
        openModalDetalle: action.cerrar,
      });
    }

    case "GUARDAR_OBSERVACION": {
      if (state.observacionesGuardadas.length === 0) {
        return Object.assign({}, state, {
          observacionesGuardadas: [{ idPaquete: action.idPaquete, observacion: action.observacion }],
        });
      } else {
        var newArray = state.observacionesGuardadas;
        var newArray2 = [];
        if (newArray.filter((item) => (item.idPaquete === action.idPaquete)).length > 0) {
          newArray2 = newArray.filter((item) => (item.idPaquete != action.idPaquete));
          newArray2.push({ idPaquete: action.idPaquete, observacion: action.observacion });
          newArray = newArray2
        } else {
          newArray.push({ idPaquete: action.idPaquete, observacion: action.observacion });
        }
        return Object.assign({}, state, {
          observacionesGuardadas: newArray,
        });
      }
    }

    case "CARGAR_EDITAR_PAQUETE": {
      return Object.assign({}, state, {
        modalEditarPaquete: action.modalEditarPaquete,
      });
    }

    case "CAMBIAR_PRESTACION_ELIMINAR": {
      return Object.assign({}, state, {
        idPrestacionEliminar: action.idPrestacionEliminar,
      });
    }

    case "CAMBIAR_PAQUETE_EDITAR": {
      //var paqueteAux = [];
      //paqueteAux.push(action.paquete)
      return Object.assign({}, state, {
        idPaqueteEditar: action.idPaqueteEditar,
        paqueteEditar: action.paquete,
        paqueteEditarMod: action.paquete,
      });
    }

    case "LIMPIAR_PAQUETE_EDITAR": {
      return Object.assign({}, state, {
        paqueteEditarMod: action.paquete,
      });
    }

    case "CAMBIAR_CODIGO_PAQUETE_PRES": {
      return Object.assign({}, state, {
        paqueteEditarMod: {
          PAQU_CODIGO_PRESTADOR: action.codigoPaquetePres,
          PAQU_CODIGO: state.paqueteEditarMod.PAQU_CODIGO,
          PRES_CCOD_INTERV: state.paqueteEditarMod.PRES_CCOD_INTERV,
          PRES_CCOD_INTERV_PRES: state.paqueteEditarMod.PRES_CCOD_INTERV_PRES,
          PAQU_INICIO_VIGENCIA: state.paqueteEditarMod.PAQU_INICIO_VIGENCIA,
          PAQU_TERMINO_VIGENCIA: state.paqueteEditarMod.PAQU_TERMINO_VIGENCIA,
          PAQU_MONTO_TOTAL: state.paqueteEditarMod.PAQU_MONTO_TOTAL,
          PAQU_DESCRIPCION: state.paqueteEditarMod.PAQU_DESCRIPCION,
          PAQU_DESC_PRESTADOR: state.paqueteEditarMod.PAQU_DESC_PRESTADOR,
          PAAT_CCOD_OLD: state.paqueteEditarMod.PAAT_CCOD_OLD,
          PRES_TDESC_INTERV_PRES: state.paqueteEditarMod.PRES_TDESC_INTERV_PRES,
          OBSERVACION: state.paqueteEditarMod.OBSERVACION,
          ARANCEL: state.paqueteEditarMod.ARANCEL,
          BILATERALIDAD: state.paqueteEditarMod.BILATERALIDAD,
          HABITACION: state.paqueteEditarMod.HABITACION,
          ID_PAQUETE: state.paqueteEditarMod.ID_PAQUETE,
          PRESTACION_SECUNDARIA: state.paqueteEditarMod.PRESTACION_SECUNDARIA,
          RIESGO: state.paqueteEditarMod.RIESGO,
          TOTAL_CLINICA: state.paqueteEditarMod.TOTAL_CLINICA,
          TOTAL_HMQ: state.paqueteEditarMod.TOTAL_HMQ,
          PRTA_NRUT_INSTITUCION: state.paqueteEditarMod.PRTA_NRUT_INSTITUCION,
          PRTA_NSECUEN_INSTITUCION: state.paqueteEditarMod.PRTA_NSECUEN_INSTITUCION,
        }
      });
    }

    case "CAMBIAR_CODIGO_INTERVENCION_PRES": {
      return Object.assign({}, state, {
        paqueteEditarMod: {
          PAQU_CODIGO_PRESTADOR: state.paqueteEditarMod.PAQU_CODIGO_PRESTADOR,
          PAQU_CODIGO: state.paqueteEditarMod.PAQU_CODIGO,
          PRES_CCOD_INTERV: state.paqueteEditarMod.PRES_CCOD_INTERV,
          PRES_CCOD_INTERV_PRES: action.codigoIntervPres,
          PAQU_INICIO_VIGENCIA: state.paqueteEditarMod.PAQU_INICIO_VIGENCIA,
          PAQU_TERMINO_VIGENCIA: state.paqueteEditarMod.PAQU_TERMINO_VIGENCIA,
          PAQU_MONTO_TOTAL: state.paqueteEditarMod.PAQU_MONTO_TOTAL,
          PAQU_DESCRIPCION: state.paqueteEditarMod.PAQU_DESCRIPCION,
          PAQU_DESC_PRESTADOR: state.paqueteEditarMod.PAQU_DESC_PRESTADOR,
          PAAT_CCOD_OLD: state.paqueteEditarMod.PAAT_CCOD_OLD,
          PRES_TDESC_INTERV_PRES: state.paqueteEditarMod.PRES_TDESC_INTERV_PRES,
          OBSERVACION: state.paqueteEditarMod.OBSERVACION,
          ARANCEL: state.paqueteEditarMod.ARANCEL,
          BILATERALIDAD: state.paqueteEditarMod.BILATERALIDAD,
          HABITACION: state.paqueteEditarMod.HABITACION,
          ID_PAQUETE: state.paqueteEditarMod.ID_PAQUETE,
          PRESTACION_SECUNDARIA: state.paqueteEditarMod.PRESTACION_SECUNDARIA,
          RIESGO: state.paqueteEditarMod.RIESGO,
          TOTAL_CLINICA: state.paqueteEditarMod.TOTAL_CLINICA,
          TOTAL_HMQ: state.paqueteEditarMod.TOTAL_HMQ,
          PRTA_NRUT_INSTITUCION: state.paqueteEditarMod.PRTA_NRUT_INSTITUCION,
          PRTA_NSECUEN_INSTITUCION: state.paqueteEditarMod.PRTA_NSECUEN_INSTITUCION,
        }
      });
    }

    case "CAMBIAR_GLOSA_PAQUETE_PRES": {
      return Object.assign({}, state, {
        paqueteEditarMod: {
          PAQU_CODIGO_PRESTADOR: state.paqueteEditarMod.PAQU_CODIGO_PRESTADOR,
          PAQU_CODIGO: state.paqueteEditarMod.PAQU_CODIGO,
          PRES_CCOD_INTERV: state.paqueteEditarMod.PRES_CCOD_INTERV,
          PRES_CCOD_INTERV_PRES: state.paqueteEditarMod.PRES_CCOD_INTERV_PRES,
          PAQU_INICIO_VIGENCIA: state.paqueteEditarMod.PAQU_INICIO_VIGENCIA,
          PAQU_TERMINO_VIGENCIA: state.paqueteEditarMod.PAQU_TERMINO_VIGENCIA,
          PAQU_MONTO_TOTAL: state.paqueteEditarMod.PAQU_MONTO_TOTAL,
          PAQU_DESCRIPCION: state.paqueteEditarMod.PAQU_DESCRIPCION,
          PAQU_DESC_PRESTADOR: action.glosaPaquetePres,
          PAAT_CCOD_OLD: state.paqueteEditarMod.PAAT_CCOD_OLD,
          PRES_TDESC_INTERV_PRES: state.paqueteEditarMod.PRES_TDESC_INTERV_PRES,
          OBSERVACION: state.paqueteEditarMod.OBSERVACION,
          ARANCEL: state.paqueteEditarMod.ARANCEL,
          BILATERALIDAD: state.paqueteEditarMod.BILATERALIDAD,
          HABITACION: state.paqueteEditarMod.HABITACION,
          ID_PAQUETE: state.paqueteEditarMod.ID_PAQUETE,
          PRESTACION_SECUNDARIA: state.paqueteEditarMod.PRESTACION_SECUNDARIA,
          RIESGO: state.paqueteEditarMod.RIESGO,
          TOTAL_CLINICA: state.paqueteEditarMod.TOTAL_CLINICA,
          TOTAL_HMQ: state.paqueteEditarMod.TOTAL_HMQ,
          PRTA_NRUT_INSTITUCION: state.paqueteEditarMod.PRTA_NRUT_INSTITUCION,
          PRTA_NSECUEN_INSTITUCION: state.paqueteEditarMod.PRTA_NSECUEN_INSTITUCION,
        }
      });
    }

    case "CAMBIAR_GLOSA_INTERVENCION_PRES": {
      return Object.assign({}, state, {
        paqueteEditarMod: {
          PAQU_CODIGO_PRESTADOR: state.paqueteEditarMod.PAQU_CODIGO_PRESTADOR,
          PAQU_CODIGO: state.paqueteEditarMod.PAQU_CODIGO,
          PRES_CCOD_INTERV: state.paqueteEditarMod.PRES_CCOD_INTERV,
          PRES_CCOD_INTERV_PRES: state.paqueteEditarMod.PRES_CCOD_INTERV_PRES,
          PAQU_INICIO_VIGENCIA: state.paqueteEditarMod.PAQU_INICIO_VIGENCIA,
          PAQU_TERMINO_VIGENCIA: state.paqueteEditarMod.PAQU_TERMINO_VIGENCIA,
          PAQU_MONTO_TOTAL: state.paqueteEditarMod.PAQU_MONTO_TOTAL,
          PAQU_DESCRIPCION: state.paqueteEditarMod.PAQU_DESCRIPCION,
          PAQU_DESC_PRESTADOR: state.paqueteEditarMod.PAQU_DESC_PRESTADOR,
          PAAT_CCOD_OLD: state.paqueteEditarMod.PAAT_CCOD_OLD,
          PRES_TDESC_INTERV_PRES: action.glosaIntervPres,
          OBSERVACION: state.paqueteEditarMod.OBSERVACION,
          ARANCEL: state.paqueteEditarMod.ARANCEL,
          BILATERALIDAD: state.paqueteEditarMod.BILATERALIDAD,
          HABITACION: state.paqueteEditarMod.HABITACION,
          ID_PAQUETE: state.paqueteEditarMod.ID_PAQUETE,
          PRESTACION_SECUNDARIA: state.paqueteEditarMod.PRESTACION_SECUNDARIA,
          RIESGO: state.paqueteEditarMod.RIESGO,
          TOTAL_CLINICA: state.paqueteEditarMod.TOTAL_CLINICA,
          TOTAL_HMQ: state.paqueteEditarMod.TOTAL_HMQ,
          PRTA_NRUT_INSTITUCION: state.paqueteEditarMod.PRTA_NRUT_INSTITUCION,
          PRTA_NSECUEN_INSTITUCION: state.paqueteEditarMod.PRTA_NSECUEN_INSTITUCION,
        }
      });
    }

    case "CARGAR_DETALLE_PRESTACION_PAQUETE": {
      //var newArray = [...state.detallePaquete];
      let prestacionSeleccionada2 = [...state.detallePaqueteMod]
      let prestacionSeleccionada = prestacionSeleccionada2[action.index];
      return Object.assign({}, state, {
        //detallePaquete: newArray,
        detalle: {
          tipoAtencion: prestacionSeleccionada.TIPO_ATENCION,
          codIsapre: prestacionSeleccionada.COD_PRES_ISAP,
          codPrestador: prestacionSeleccionada.COD_PRES_PREST,
          glosa: prestacionSeleccionada.GLOSA_PRES_PREST,
          imed: prestacionSeleccionada.ITEM_IMED,
          codProf: prestacionSeleccionada.COD_PROF,
          cantidad: prestacionSeleccionada.CANT_PRES,
          medHot: prestacionSeleccionada.MEDICO_U_HOTELERIA,
          unidad: prestacionSeleccionada.UNIDAD,
          monto: prestacionSeleccionada.MONTO_UNITARIO,
          rutBono: prestacionSeleccionada.BONO_RUT,
          grupo: prestacionSeleccionada.GRBA_CCOD,
          index: action.index,
        }
      });
    }

    case "CARGAR_DETALLE_NUEVA_PRESTACION": {
      return Object.assign({}, state, {
        detalle: {
          tipoAtencion: "",
          codIsapre: "",
          codPrestador: "",
          glosa: "",
          imed: "",
          codProf: "",
          cantidad: "",
          medHot: "",
          unidad: "",
          monto: "",
          rutBono: "",
          index: "",
        }
      });
    }

    case "GUARDAR_DETALLE_PRESTACION": {
      let detalleActual = [...state.detallePaqueteMod];
      for (let i = 0; i < detalleActual.length; i++) {
        if (action.detalle.index === i) {
          detalleActual[i] = {
            ID_PAQUETE: state.idPaqueteEditar,
            TIPO_ATENCION: (action.detalle.tipoAtencion).toUpperCase(),
            COD_PRES_ISAP: Number(action.detalle.codIsapre),
            COD_PRES_PREST: action.detalle.codPrestador,
            GLOSA_PRES_PREST: action.detalle.glosa,
            ITEM_IMED: Number(action.detalle.imed),
            COD_PROF: action.detalle.codProf,
            CANT_PRES: Number(action.detalle.cantidad),
            MONTO_UNITARIO: Number(action.detalle.monto),
            UNIDAD: (action.detalle.unidad).toUpperCase(),
            MEDICO_U_HOTELERIA: (action.detalle.medHot).toUpperCase(),
            BONO_RUT: Number(action.detalle.rutBono),
            GRBA_CCOD: action.detalle.grupo,
          }
        }
      }
      return Object.assign({}, state, {
        detallePaqueteMod: detalleActual
      });
    }

    case "GUARDAR_DETALLE_NUEVA_PRESTACION": {
      let detalleActual = [...state.detallePaqueteMod];
      detalleActual.push({
        ID_PAQUETE: state.idPaqueteEditar,
        TIPO_ATENCION: (action.detalle.tipoAtencion).toUpperCase(),
        COD_PRES_ISAP: Number(action.detalle.codIsapre),
        COD_PRES_PREST: action.detalle.codPrestador,
        GLOSA_PRES_PREST: action.detalle.glosa,
        ITEM_IMED: Number(action.detalle.imed),
        COD_PROF: action.detalle.codProf,
        CANT_PRES: Number(action.detalle.cantidad),
        MONTO_UNITARIO: Number(action.detalle.monto),
        UNIDAD: (action.detalle.unidad).toUpperCase(),
        MEDICO_U_HOTELERIA: (action.detalle.medHot).toUpperCase(),
        BONO_RUT: Number(action.detalle.rutBono),
        GRBA_CCOD: 0,
      });
      return Object.assign({}, state, {
        detallePaqueteMod: detalleActual
      });
    }

    case "CAMBIAR_TIPO_ATENCION": {
      const detalle = Object.assign({}, state.detalle, {
        tipoAtencion: action.tipoAtencion,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_CODIGO_PRESTACION_ISAPRE": {
      const detalle = Object.assign({}, state.detalle, {
        codIsapre: action.codIsapre,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_CODIGO_PRESTACION_PRESTADOR": {
      const detalle = Object.assign({}, state.detalle, {
        codPrestador: action.codPrestador,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_CODIGO_PROFESIONAL": {
      const detalle = Object.assign({}, state.detalle, {
        codProf: action.codProf,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_GLOSA_PRESTADOR": {
      const detalle = Object.assign({}, state.detalle, {
        glosa: action.glosa,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_ITEM_IMED": {
      const detalle = Object.assign({}, state.detalle, {
        imed: action.imed,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_CANTIDAD": {
      const detalle = Object.assign({}, state.detalle, {
        cantidad: action.cantidad,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_MEDICO_HOTELERIA": {
      const detalle = Object.assign({}, state.detalle, {
        medHot: action.medHot,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_UNIDAD": {
      const detalle = Object.assign({}, state.detalle, {
        unidad: action.unidad,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_MONTO": {
      const detalle = Object.assign({}, state.detalle, {
        monto: action.monto,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "CAMBIAR_RUT_BONO": {
      const detalle = Object.assign({}, state.detalle, {
        rutBono: action.rutBono,
      });
      return Object.assign({}, state, {
        detalle,
      });
    }

    case "ABRIR_MODAL_DETALLE_PRESTACION": {
      return Object.assign({}, state, {
        openModalEditarPrestacion: action.estado,
      })
    }

    case "CAMBIAR_VIGENCIA_PRESTACION_EDICION": {
      return Object.assign({}, state, {
        paqueteEditarMod: {
          PAQU_CODIGO_PRESTADOR: state.paqueteEditarMod.PAQU_CODIGO_PRESTADOR,
          PAQU_CODIGO: state.paqueteEditarMod.PAQU_CODIGO,
          PRES_CCOD_INTERV: state.paqueteEditarMod.PRES_CCOD_INTERV,
          PRES_CCOD_INTERV_PRES: state.paqueteEditarMod.PRES_CCOD_INTERV_PRES,
          PAQU_INICIO_VIGENCIA: state.paqueteEditarMod.PAQU_INICIO_VIGENCIA,
          PAQU_TERMINO_VIGENCIA: action.vigenciaPrestacionEdicion,
          PAQU_MONTO_TOTAL: state.paqueteEditarMod.PAQU_MONTO_TOTAL,
          PAQU_DESCRIPCION: state.paqueteEditarMod.PAQU_DESCRIPCION,
          PAQU_DESC_PRESTADOR: state.paqueteEditarMod.PAQU_DESC_PRESTADOR,
          PAAT_CCOD_OLD: state.paqueteEditarMod.PAAT_CCOD_OLD,
          PRES_TDESC_INTERV_PRES: state.paqueteEditarMod.PRES_TDESC_INTERV_PRES,
          OBSERVACION: state.paqueteEditarMod.OBSERVACION,
          ARANCEL: state.paqueteEditarMod.ARANCEL,
          BILATERALIDAD: state.paqueteEditarMod.BILATERALIDAD,
          HABITACION: state.paqueteEditarMod.HABITACION,
          ID_PAQUETE: state.paqueteEditarMod.ID_PAQUETE,
          PRESTACION_SECUNDARIA: state.paqueteEditarMod.PRESTACION_SECUNDARIA,
          RIESGO: state.paqueteEditarMod.RIESGO,
          TOTAL_CLINICA: state.paqueteEditarMod.TOTAL_CLINICA,
          TOTAL_HMQ: state.paqueteEditarMod.TOTAL_HMQ,
          PRTA_NRUT_INSTITUCION: state.paqueteEditarMod.PRTA_NRUT_INSTITUCION,
          PRTA_NSECUEN_INSTITUCION: state.paqueteEditarMod.PRTA_NSECUEN_INSTITUCION,
        }
      });


      return Object.assign({}, state, {
        vigenciaPrestacionEdicion: action.vigenciaPrestacionEdicion,
        inicioVigenciaArancelErr: action.error,
      });
    }

    // Reducers should always return a default initial state.
    default:
      return state;
  }
};

export default grillaBusquedaPQReducer;
